import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  municipalityId: number,
 *  reportingYear: number,
 *  payment: Date,
 *  announced: number }} AllocationItem
 */

const api = new Api("api/amo/allocations");

/**
 * @returns {Promise<AxiosResponse<AllocationItem[]>>}
 */
export const getAll = () => api.get();

/**
 * @param {AllocationItem} payload
 * @returns {Promise<AxiosResponse>}
 */
export const post = (payload) => api.post("", payload);

/**
 * @param {AllocationItem[]} payload
 * @returns {Promise<AxiosResponse>}
 */
export const postMultiple = (payload) => api.post("/multiple", payload);
